import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import {
  PagingState,
  EditingState,
  CustomPaging,
  FilteringState,
  IntegratedFiltering,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableEditRow,
  TableEditColumn,
  TableFilterRow,
  TableColumnVisibility,
} from "@devexpress/dx-react-grid-material-ui";
import {
  QueryString,
  Create,
  Update,
  Remove,
  ExportXlsx,
  TIMER_FILTER,
  APPNAME_GERACAOXML,
} from "../utils/react_grid_utils";
import { ChNumberTypeProvider } from "../utils/react_grid_ch_number_column";
import { ConveniosTypeProvider } from "../utils/react_grid_convenios_column";
import { editColumnMessages } from "../utils/react_grid_edit_command_localization";
import Import from "../utils/import";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import Header from "../Header";

const getRowId = (row) => row.id;
const api_resource = "matriz-ch-procedimento";

export default function MatrizChProcedimentoTable() {
  const alert = useAlert();

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(10);
  const [totalItens, setTotalItens] = useState(0);
  const [rows, setRows] = useState([]);
  const [tableColumnExtensions] = useState([
    { columnName: "id", width: 60 },
    { columnName: "convenio", width: 220 },
    { columnName: "plano", width: 280 },
    { columnName: "tuss", width: 130 },
    { columnName: "ch", width: 100 },
    { columnName: "descricao", width: 300 },
  ]);
  const [defaultHiddenColumnNames] = useState(["id"]);
  const [filteringStateColumnExtensions] = useState([
    { columnName: "ch", filteringEnabled: false },
  ]);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [filtersApi, setFiltersApi] = useState([]);

  function get(page, filters) {
    const queryString = QueryString(page, pageSize, filters);
    http.get(`${api_resource}` + queryString).then(
      (response) => {
        setRows(response?.data?.data);
        setTotalItens(response?.data?.total);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  useEffect(() => {
    get(0, []);
  }, []);

  const [timer, setTimer] = useState(null);

  function handleFilters(filters) {
    clearTimeout(timer);
    setFiltersApi(filters);
    setTimer(
      setTimeout(function () {
        get(pageIndex, filters);
      }, TIMER_FILTER)
    );
  }

  function handlePage(page) {
    setPageIndex(page);
    get(page, filtersApi);
  }

  const changeAddedRows = (value) => {
    const initialized = value.map((row) => (Object.keys(row).length ? row : {}));
    setAddedRows(initialized);
  };

  const commitChanges = ({ added, changed, deleted }) => {
    let changedRows;
    if (added) {
      Create(api_resource, added[0], alert).then((response) => {
        var new_row = response.data[0];
        const startingAddedId = rows.length > 0 ? rows[rows.length - 1].id + 1 : 0;
        changedRows = [
          ...added.map((row, index) => ({
            id: startingAddedId + index,
            ...new_row,
          })),
          ...rows,
        ];
        setRows(changedRows);
      });
    }
    if (changed) {
      changedRows = rows.map((row) =>
        changed[row.id] ? { ...row, ...changed[row.id] } : row
      );
      var item = changedRows.find((row) => changed[row.id]);
      Update(api_resource, item, alert).then((response) => {
        var changed_row = response.data[0];
        changedRows = rows.map((row) =>
          changed[row.id] ? { ...row, ...changed_row } : row
        );
        setRows(changedRows);
      });
    }
    if (deleted) {
      var confirmado = window.confirm("Confirma a exclusão?");
      if (confirmado === true) {
        Remove(api_resource, deleted[0], alert);
        const deletedSet = new Set(deleted);
        changedRows = rows.filter((row) => !deletedSet.has(row.id));
      } else {
        changedRows = rows;
      }
      setRows(changedRows);
    }
  };

  var columns = [
    { name: "id", title: "ID" },
    { name: "convenio", title: "Convênio" },
    { name: "plano", title: "Plano" },
    { name: "tuss", title: "Código TUSS" },
    { name: "ch", title: "CH" },
    { name: "descricao", title: "Descrição" },
  ];

  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2>CH por Procedimento</h2>
            <p style={{ color: "#888", marginTop: 4 }}>
              CH específico por Convênio + Plano + Código TUSS
            </p>
          </div>
          <div className="col-lg-2">
            <button
              className="btn btn-primary btn-sm"
              style={{ marginTop: "20px" }}
              type="button"
              onClick={() => ExportXlsx(api_resource, alert)}
            >
              Exportar
            </button>
            <Import
              api_resource={api_resource}
              alert={alert}
              appname={APPNAME_GERACAOXML}
              onFinish={() => get(0, [])}
            />
          </div>
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox">
                <div className="ibox-content">
                  <Grid rows={rows} columns={columns} getRowId={getRowId}>
                    <PagingState
                      currentPage={pageIndex}
                      pageSize={pageSize}
                      onCurrentPageChange={handlePage}
                    />
                    <EditingState
                      editingRowIds={editingRowIds}
                      onEditingRowIdsChange={setEditingRowIds}
                      rowChanges={rowChanges}
                      onRowChangesChange={setRowChanges}
                      addedRows={addedRows}
                      onAddedRowsChange={changeAddedRows}
                      onCommitChanges={commitChanges}
                      columnExtensions={tableColumnExtensions}
                    />
                    <FilteringState
                      onFiltersChange={handleFilters}
                      columnExtensions={filteringStateColumnExtensions}
                    />
                    <IntegratedFiltering />
                    <Table columnExtensions={tableColumnExtensions} />
                    <TableHeaderRow />
                    <TableColumnVisibility
                      defaultHiddenColumnNames={defaultHiddenColumnNames}
                    />
                    <ChNumberTypeProvider for={["ch"]} />
                    <ConveniosTypeProvider for={["convenio"]} />
                    <TableEditRow />
                    {authenticatedUserContext.allow_edit(APPNAME_GERACAOXML) === true ? (
                      <TableEditColumn
                        showAddCommand={!addedRows.length}
                        showEditCommand
                        showDeleteCommand
                        messages={editColumnMessages}
                      />
                    ) : (
                      <></>
                    )}
                    <CustomPaging totalCount={totalItens} />
                    <PagingPanel />
                    <TableFilterRow />
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
